// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Eh3Z","textarea":"styles_textarea__1lQ9m"};